module.exports = __webpack_public_path__ + "img/@go_to_work_img_00_off.1e0e9276.jpg";